import React, { useState } from 'react';

const LLPName = () => {
  const [activeTab, setActiveTab] = useState('name');

  return (
    <div className="p-6 max-w-5xl mx-auto">
      {/* Tabs */} 
      <div className="flex gap-4  ">
        <button
          onClick={() => setActiveTab('name')}
          className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
            activeTab === 'name' ? 'bg-[#b7b7a1] text-white' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
          }`}
        >
        NAME AVAILABILITY FOR A LIMITED LIABILITY PARTNERSHIP (LLP) FIRM
        </button>
        <button
          onClick={() => setActiveTab('registration')}
          className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
            activeTab === 'registration' ?  'bg-[#b7b7a1] text-white' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
          }`}
        >
        LIMITED LIABILITY PARTNERSHIP (LLP) FIRM REGISTRATION
        </button>

      </div>

      {/* Tab Content */}
      <div className="mt-6 text-gray-800 space-y-4">
        {activeTab === 'name' && (
          <>
            <h2 className="text-xl font-bold">NAME AVAILABILITY FOR A LIMITED LIABILITY PARTNERSHIP (LLP) FIRM</h2>
                <p className="text-md text-justify text-[#444] mb-8">Our team of experienced legal experts and company secretaries is here to assist customers throughout the entire process of Limited Liability Partnership (LLP) firm registration. Starting with the crucial step of checking the availability of the desired firm name, we ensure compliance with regulatory guidelines and help avoid potential conflicts. Once the name is confirmed, our experts guide clients through the necessary documentation and legal requirements, ensuring that all forms are accurately prepared and submitted to the appropriate authorities. With our in-depth knowledge of the registration process, we streamline the experience, providing personalized support at every stage, from initial inquiries to the successful establishment of the LLP. Our commitment is to empower entrepreneurs with the legal foundation they need to launch and grow their businesses with confidence.</p>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Legal Compliance:</strong> Ensures the name meets regulatory requirements.</li>
              <li><strong>Uniqueness:</strong> Confirms the name is not already in use.</li>
              <li><strong>Brand Protection:</strong> Avoids trademark conflicts and protects reputation.</li>
              <li><strong>Facilitating Registration:</strong> Helps in smooth registration without delays.</li>
              <li><strong>Professionalism:</strong> A unique name enhances your business image.</li>
            </ul>
            <p>💡 Always research using business registries and trademark databases before finalizing a name.</p>
          </>
        )}

        {activeTab === 'registration' && (
          <>
            <h2 className="text-xl font-bold">LIMITED LIABILITY PARTNERSHIP (LLP) FIRM REGISTRATION</h2>
            <ol className="list-decimal pl-5 space-y-2">
              <li><strong>Choose a Suitable Name</strong> – Check availability and follow naming conventions.</li>
              <li><strong>Designate Partners</strong> – Minimum two designated partners required.</li>
              <li><strong>Obtain Digital Signature Certificates (DSC)</strong></li>
              <li><strong>Obtain Director Identification Number (DIN)</strong></li>
              <li><strong>Draft the LLP Agreement</strong> – Define roles, profit sharing, etc.</li>
              <li><strong>Filing for Registration</strong> – Submit incorporation and agreement forms.</li>
              <li><strong>Pay Fees</strong> – Varies by jurisdiction and capital contribution.</li>
              <li><strong>Certificate of Incorporation</strong> – Official recognition of your LLP.</li>
              <li><strong>Post-Incorporation Compliance</strong> – Register for GST, open a bank account, etc.</li>
              <li><strong>Maintain Compliance</strong> – Annual returns, accounting, tax filing.</li>
            </ol>
            <p>📌 It’s best to consult a legal expert or company secretary for accurate filing and compliance.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default LLPName;
